export const buildCanonicalPosSizingPortfolioRows = (rows) => {
    if (!Array.isArray(rows) || rows.length === 0) {
        throw new Error('Position sizing calculation returned invalid canonical rows.');
    }

    const seenCogniveIds = new Set();
    return rows.map((row) => {
        const cogniveId = typeof row?.cognive_id === 'string' ? row.cognive_id.trim() : '';
        const roundedGmv = row?.pos_gmv_dollar;
        const preciseGmv = row?.pos_gmv_dollar_precise;
        const hasGmv = preciseGmv != null || roundedGmv != null;
        const hasInvalidGmv = [roundedGmv, preciseGmv].some(
            (value) => value != null && (typeof value !== 'number' || !Number.isFinite(value)),
        );
        if (
            !cogniveId
            || seenCogniveIds.has(cogniveId)
            || !hasGmv
            || hasInvalidGmv
        ) {
            throw new Error('Position sizing calculation returned invalid canonical rows.');
        }
        seenCogniveIds.add(cogniveId);
        return {
            cognive_id: cogniveId,
            pos_gmv_dollar: roundedGmv != null ? roundedGmv : null,
            pos_gmv_dollar_precise: preciseGmv != null ? preciseGmv : null,
        };
    });
};
